exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".name-title{height:100%;width:100%;font-size:108px;position:absolute;z-index:-1;perspective:1000px}.home-title-st{display:inline-block;white-space:pre-wrap}.name-title__title-container{transform:translateY(-50%);position:relative;top:50%}.name-title__main-container{perspective:1000px}.name-title__title{font-family:SorrenMedium;font-size:1em;letter-spacing:.3em;text-transform:uppercase;color:#fff;text-align:center;position:relative;white-space:nowrap}@media screen and (max-width:1500px){.name-title__title{font-size:90px}}.name-title__subtitle{font-size:14px;padding-top:60px;line-height:2em;font-family:PlayfairDisplay;font-style:italic;color:#cce4ff;position:relative;text-align:center;margin:auto;max-width:250px}.subtitle-lines{display:inline-block}.name-title__square{position:absolute;width:6em;height:1.6em;top:50%;left:50%;transform:translate3d(-50%,-50%,-300px);border:15px solid #001429;z-index:-1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-d08ed304!./~/postcss-loader!./~/sass-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/spa/Home/HomeTitle.vue
// module id = 129
// module chunks = 0